import * as types from 'constants/ActionTypes';
import { SUCCESS, ERROR } from 'constants/AppConstants';
import { t } from 'i18next';

const initManagePaymentsBanner = {
  open: false,
  severity: '',
  title: '',
  message: '',
};

const initPaymentValues = {
  PrePayment: null,
  MonthlyPayment: null,
  PrePaymentError: false,
  MonthlyPaymentError: false,
};

const paymentInfoInit = {
  firstName: '',
  lastName: '',
  cardNumber: '',
  cardType: '',
  expirationDateMonth: '',
  expirationDateYear: '',
};

const initState = {
  nextPlanLevelDetails: {},
  loading: false,
  loadError: false,
  paymentValues: initPaymentValues,
  suspendMonthlyPrepay: null,
  saveloading: false,
  managePaymentsBanner: initManagePaymentsBanner,
  updatedCardDetails: { ...paymentInfoInit, isUpdated: false },
  purchaseOrder: '',
  cardData: null,
  ccConsent: null,
  cardDetailErrors: paymentInfoInit,
  accountUpdateLoading: false,
  accountUpdateSuccess: null,
  accountUpdateError: null,
};

export default (state = initState, action = {}) => {
  switch (action.type) {
    case types.MANAGE_PAYMENT_OPTIONS_LOADING: {
      return {
        ...state,
        loading: true,
        managePaymentsBanner: initManagePaymentsBanner,
        paymentValues: initPaymentValues,
      };
    }
    case types.MANAGE_PAYMENT_OPTIONS_SUCCESS: {
      return {
        ...state,
        nextPlanLevelDetails: action.nextPlanLevel,
        loading: false,
        loadError: false,
      };
    }
    case types.MANAGE_PAYMENT_OPTIONS_ERROR: {
      return {
        ...state,
        loading: false,
        loadError: true,
      };
    }
    case types.MANAGE_PAYMENT_OPTIONS_AMOUNT_UPDATES: {
      return {
        ...state,
        paymentValues: {
          ...state.paymentValues,
          [action.id]: action.value,
          [`${action.id}Error`]: false,
        },
      };
    }
    case types.MANAGE_PAYMENT_OPTIONS_AMOUNT_UPDATES_ERROR: {
      return {
        ...state,
        paymentValues: {
          ...state.paymentValues,
          [action.id]: action.value,
        },
      };
    }
    case types.MANAGE_PAYMENT_OPTIONS_SUSPEND_MONTHLY_PREPAY: {
      return {
        ...state,
        suspendMonthlyPrepay: action.suspendMonthlyPrepayValues,
      };
    }
    case types.SAVE_SUSPEND_PREPAY_OPTIONS_LOADING: {
      return {
        ...state,
        saveloading: true,
      };
    }
    case types.SAVE_SUSPEND_PREPAY_OPTIONS_SUCCESS: {
      return {
        ...state,
        saveloading: false,
        managePaymentsBanner: { open: true, severity: SUCCESS, message: t('manage_payment__suspend_prepay_save_success_message') },
      };
    }
    case types.SAVE_SUSPEND_PREPAY_OPTIONS_ERROR: {
      return {
        ...state,
        saveloading: false,
        managePaymentsBanner: {
          open: true,
          severity: ERROR,
          message: action.errors || t('text_alert_settings__save_error_message'),
        },
      };
    }
    case types.CLOSE_SUSPEND_PREPAY_OPTIONS_BANNER: return { ...state, managePaymentsBanner: initManagePaymentsBanner };
    case types.UPDATE_MANAGE_PAYMENTS_CARD_DETAILS: {
      return {
        ...state,
        updatedCardDetails: { ...state.updatedCardDetails, ...action.cardDetails },
      };
    }
    case types.UPDATE_MANAGE_PAYMENTS_CARD_CONSENT: {
      return {
        ...state,
        ccConsent: action.ccConsent,
      };
    }
    case types.RESET_MANAGE_PAYMENT_ACCOUNT_UPDATE_DETAILS: {
      return {
        ...state,
        updatedCardDetails: { ...paymentInfoInit, isUpdated: false },
        ccConsent: null,
        cardDetailErrors: paymentInfoInit,
        cardData: null,
        purchaseOrder: '',
        accountUpdateLoading: false,
        accountUpdateError: null,
        paymentValues: initPaymentValues,
      };
    }
    case types.UPDATE_MANAGE_PAYMENT_PURCHASE_ORDER_VALUE: {
      return {
        ...state,
        purchaseOrder: action.purchaseOrder,
      };
    }
    case types.UPDATE_MANAGE_PAYMENTS_PAYMENT_INFO_ERRORS: {
      return {
        ...state,
        cardDetailErrors: action.paymentValidationErrors,
      };
    }
    case types.UPDATE_ACCOUNT_PAYMENT_OPTIONS_LOADING: {
      return {
        ...state,
        accountUpdateLoading: true,
        accountUpdateError: null,
      };
    }
    case types.UPDATE_ACCOUNT_PAYMENT_OPTIONS_SUCCESS: {
      return {
        ...state,
        accountUpdateLoading: false,
        accountUpdateSuccess: action.accountUpdateSuccess,
      };
    }
    case types.UPDATE_ACCOUNT_PAYMENT_OPTIONS_ERROR: {
      return {
        ...state,
        accountUpdateLoading: false,
        accountUpdateError: true,
      };
    }
    case types.RESET_UPDATE_ACCOUNT_SUCCESS_RESPONSE_DETAILS: {
      return {
        ...state,
        accountUpdateSuccess: null,
      };
    }
    default:
      return state;
  }
};
